/**
 * Created by zad on 17/10/11.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// eslint-disable-next-line no-underscore-dangle
const _type = {
  size: ['lg', '2x', '3x', '4x', '5x'],
  rotate: [90, 180, 270],
};

export default class Icon extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    size: PropTypes.string,
    fixedWidth: PropTypes.bool,
    spin: PropTypes.bool,
    pulse: PropTypes.bool,
    rotate: PropTypes.number,
  };

  render() {
    // eslint-disable-next-line object-curly-newline
    const { name, size, fixedWidth, spin, pulse, rotate, className, ...props } = this.props;
    const iconClass = classNames('fa', `fa-${name}`, className, {
      [`fa-${size}`]: size && _type.size.includes(size),
      [`fa-rotate-${rotate}`]: rotate && _type.rotate.includes(rotate),
      'fa-fw': fixedWidth,
      'fa-spin': spin,
      'fa-pulse': pulse,
    });
    return (
      <i {...props} className={iconClass}/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js